import React from 'react';
import { AlertTriangle } from '../../icons';

const ErrorDisplay = ({ error, title = 'Error' }) => {
  if (!error) return null;

  const message =
    typeof error === 'object' && error !== null && error.message ? error.message : String(error);

  return (
    <div
      role="alert"
      className="my-4 p-3.5 bg-danger-soft border border-danger/40 rounded-card text-sm text-primary flex items-start gap-3"
    >
      <AlertTriangle className="w-5 h-5 text-danger flex-shrink-0 mt-0.5" />
      <div>
        <strong className="text-danger">{title}:</strong> {message}
      </div>
    </div>
  );
};

export default ErrorDisplay;
